module.exports = __webpack_public_path__ + "static/img/bucanyu.bfdb530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bucanyu.png
// module id = HcF0
// module chunks = 1